<template>
  <div class="notifications-header">
    <component :is="titleTag" class="notifications-header__title">{{ $t('notifications-center.title') }}</component>
    <BaseNotification class="notifications-header__count" :amount="unreadCount" />
    <button v-if="unreadCount > 0" class="notifications-header__mark-all" @click="$emit('mark-all')">
      {{ $t('notifications-center.mark-all-read') }}
    </button>
  </div>
</template>

<script>
import BaseNotification from '@/components/base/BaseNotification.vue';

export default {
  name: 'NotificationsHeader',
  components: {
    BaseNotification,
  },
  props: {
    unreadCount: {
      type: Number,
      required: true,
    },
    // The notifications page names itself with an h1.
    titleTag: {
      type: String,
      default: 'span',
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-header {
  display: flex;
  align-items: center;
  gap: $space-sm;

  &__title {
    margin: 0;
    color: $color-text-title;
    font-size: $font-size-bigger;
    font-weight: $font-weight-bold;
  }

  &__count {
    background-color: $color-accent-100;
    color: $color-accent-500;
    font-size: $font-size-xsmall;

    &.zero {
      background-color: $color-surface-sunken;
      color: $color-text-title;
    }
  }

  &__mark-all {
    margin-left: auto;
    padding: 0;
    border: none;
    background: none;
    color: $color-accent-500;
    font-size: $font-size-small;
    cursor: pointer;

    &:hover {
      color: $color-text-action-hover;
    }
  }
}
</style>
